import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { JoveLogoLoading } from '@jove-frontend/mui';
import { REQUEST_SUCCESS_CODE, apiGetQuoteComparisonPriceInformation, apiPatchQuote } from '@jove-frontend/uikit';
import { Box } from '@mui/material';
import clsx from 'clsx';
import OnlyJoveView from './onlyJove';
import PolicyCompareView from './policyCompare';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PriceComparisonCombineInfoView = function PriceComparisonCombineInfoView(props) {
  var quoteId = props.quoteId,
      defaultCountry = props.defaultCountry,
      updateQuoteInfo = props.updateQuoteInfo,
      disableSwitchCountry = props.disableSwitchCountry,
      hideCountry = props.hideCountry,
      priceCombineInfoValueChange = props.priceCombineInfoValueChange,
      hideLoading = props.hideLoading,
      quoteDetailsInfo = props.quoteDetailsInfo;

  var _useState = useState(null),
      priceCombineInfo = _useState[0],
      setPriceCombineInfo = _useState[1];

  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      patchLoading = _useState3[0],
      setPatchLoading = _useState3[1];
  /**
   * requests
   */


  var requestGetPriceComparisonInfo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$apiGetQuoteCom, _yield$apiGetQuoteCom2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!hideLoading) {
                setLoading(true);
              }

              setPriceCombineInfo(null);
              _context.next = 4;
              return apiGetQuoteComparisonPriceInformation({
                quoteId: quoteId
              });

            case 4:
              _yield$apiGetQuoteCom = _context.sent;
              _yield$apiGetQuoteCom2 = _slicedToArray(_yield$apiGetQuoteCom, 1);
              res = _yield$apiGetQuoteCom2[0];

              if ((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE) {
                if (res !== null && res !== void 0 && res.data) {
                  setPriceCombineInfo(_objectSpread(_objectSpread({}, res.data), {}, {
                    quoteDetailsInfo: quoteDetailsInfo
                  }));
                }

                priceCombineInfoValueChange === null || priceCombineInfoValueChange === void 0 ? void 0 : priceCombineInfoValueChange(res === null || res === void 0 ? void 0 : res.data);
              }

              setLoading(false);
              return _context.abrupt("return", res);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestGetPriceComparisonInfo() {
      return _ref.apply(this, arguments);
    };
  }();

  var requestUpdateQuoteInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
      var _yield$apiPatchQuote, _yield$apiPatchQuote2, res;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setPatchLoading(true);
              _context2.next = 3;
              return apiPatchQuote(quoteId, data);

            case 3:
              _yield$apiPatchQuote = _context2.sent;
              _yield$apiPatchQuote2 = _slicedToArray(_yield$apiPatchQuote, 1);
              res = _yield$apiPatchQuote2[0];

              if (res) {
                updateQuoteInfo === null || updateQuoteInfo === void 0 ? void 0 : updateQuoteInfo(data);
              }

              setPatchLoading(false);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function requestUpdateQuoteInfo(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * effects
   */


  useEffect(function () {
    if (quoteId) {
      requestGetPriceComparisonInfo();
    }
  }, [quoteId]);
  useEffect(function () {
    if (quoteDetailsInfo) {
      setPriceCombineInfo(_objectSpread(_objectSpread({}, priceCombineInfo), {}, {
        quoteDetailsInfo: quoteDetailsInfo
      }));
    }
  }, [quoteDetailsInfo]);
  /**
   * methods
   */

  var quoteValueChangeAction = function quoteValueChangeAction(data) {
    requestUpdateQuoteInfo(data);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('relative flex flex-col', loading ? 'min-h-[200px]' : ''),
    children: [(loading || patchLoading) && /*#__PURE__*/_jsx(JoveLogoLoading, {}), !!priceCombineInfo && priceCombineInfo.show_comparison && /*#__PURE__*/_jsx(PolicyCompareView, {
      info: priceCombineInfo,
      valueChange: quoteValueChangeAction,
      defaultCountry: defaultCountry,
      disableSwitchCountry: disableSwitchCountry,
      hideCountry: hideCountry
    }), !!priceCombineInfo && !priceCombineInfo.show_comparison && /*#__PURE__*/_jsx(OnlyJoveView, {
      info: priceCombineInfo,
      valueChange: quoteValueChangeAction,
      defaultCountry: defaultCountry,
      disableSwitchCountry: disableSwitchCountry,
      hideCountry: hideCountry
    })]
  });
};